import React from 'react';


export const Cleaning2 = ({ color }: { color?: string }): JSX.Element => {
    const className = 'icon icon--cleaning2';
    color = color || '#005FAA';

    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...{ className }}>
            <path d="M3.486 7.965C3.654 7.985 3.826 7.998 4 8C4.79 8.009 5.539 7.822 6 7.5C6.461 7.18 7.21 6.993 8 7C8.79 6.993 9.539 7.18 10 7.5C10.461 7.822 11.21 8.009 12 8C12.79 8.009 13.539 7.822 14 7.5C14.461 7.18 15.21 6.993 16 7C16.79 6.993 17.539 7.18 18 7.5C18.461 7.822 19.21 8.009 20 8C20.17 8 20.339 7.986 20.503 7.966M3 5L4.721 15.329C4.79888 15.796 5.0399 16.2202 5.40118 16.5262C5.76245 16.8322 6.22056 17.0001 6.694 17H17.306C17.7794 17.0001 18.2375 16.8322 18.5988 16.5262C18.9601 16.2202 19.2011 15.796 19.279 15.329L21 5M5 20H19" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    );
};

export default Cleaning2;

